import { render, staticRenderFns } from "./Lexology.vue?vue&type=template&id=56c0f8f2&"
import script from "./Lexology.vue?vue&type=script&lang=js&"
export * from "./Lexology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports